var moduleMap = {
	"./ProcessManager": () => {
		return __webpack_require__.e(4816).then(() => (() => ((__webpack_require__(84816)))));
	},
	"./ppPrivateFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(2310), __webpack_require__.e(4305), __webpack_require__.e(8960), __webpack_require__.e(389), __webpack_require__.e(1858), __webpack_require__.e(6620), __webpack_require__.e(4838), __webpack_require__.e(7087)]).then(() => (() => ((__webpack_require__(31970)))));
	},
	"./appStateManager": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(2310), __webpack_require__.e(4305), __webpack_require__.e(8960), __webpack_require__.e(389), __webpack_require__.e(1858), __webpack_require__.e(6620), __webpack_require__.e(4838), __webpack_require__.e(2292)]).then(() => (() => ((__webpack_require__(92778)))));
	},
	"./ppUserAccountService": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(2310), __webpack_require__.e(4305), __webpack_require__.e(8960), __webpack_require__.e(389), __webpack_require__.e(1858), __webpack_require__.e(6620), __webpack_require__.e(4838), __webpack_require__.e(4196)]).then(() => (() => ((__webpack_require__(80780)))));
	},
	"./ppAppEndpointsConfig": () => {
		return Promise.all([__webpack_require__.e(1858), __webpack_require__.e(6691)]).then(() => (() => ((__webpack_require__(56691)))));
	},
	"./fetchers/ppWebhook": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(2310), __webpack_require__.e(4305), __webpack_require__.e(8960), __webpack_require__.e(389), __webpack_require__.e(1858), __webpack_require__.e(6620), __webpack_require__.e(4838), __webpack_require__.e(7045)]).then(() => (() => ((__webpack_require__(89815)))));
	},
	"./fetchers/ppPrivateFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(2310), __webpack_require__.e(4305), __webpack_require__.e(8960), __webpack_require__.e(389), __webpack_require__.e(1858), __webpack_require__.e(6620), __webpack_require__.e(4838), __webpack_require__.e(7087)]).then(() => (() => ((__webpack_require__(31970)))));
	},
	"./fetchers/ppCustomNotification": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(2310), __webpack_require__.e(4305), __webpack_require__.e(8960), __webpack_require__.e(5673), __webpack_require__.e(389), __webpack_require__.e(1858), __webpack_require__.e(6620), __webpack_require__.e(4838), __webpack_require__.e(1648), __webpack_require__.e(7538)]).then(() => (() => ((__webpack_require__(10936)))));
	},
	"./fetchers/ppTrackingWidgetFetcher": () => {
		return Promise.all([__webpack_require__.e(3019), __webpack_require__.e(2310), __webpack_require__.e(4305), __webpack_require__.e(8960), __webpack_require__.e(389), __webpack_require__.e(1858), __webpack_require__.e(6620), __webpack_require__.e(4838), __webpack_require__.e(8220)]).then(() => (() => ((__webpack_require__(68018)))));
	},
	"./constants/productExperience.constant": () => {
		return __webpack_require__.e(3638).then(() => (() => ((__webpack_require__(23638)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});